export default {
      id: "plus-usage",
      viewBox: "0 0 19 19",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#plus",
      toString: function () {
        return this.url;
      }
    }